import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { MatPaginator, MatSort } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { of as observableOf } from 'rxjs/observable/of';
import { debounceTime, distinctUntilChanged, startWith, tap, delay } from 'rxjs/operators';
import { catchError, map, switchMap } from 'rxjs/operators';
import { merge } from 'rxjs/observable/merge';
import { fromEvent } from 'rxjs/observable/fromEvent';

import { DriverDataSource } from './drivers.datasource';
import { IDriverForUserListRow } from '../../../_models/drivers';
import { PaginationParams } from '../../../_models/generic';
import { AuthenticationService } from 'app/_services';
import { DriverService } from 'app/_services/drivers.service';
import { OnChanges } from "@angular/core";

@Component({
  selector: 'app-dl-single-select-drivers',
  templateUrl: './dl-single-select-drivers.component.html',
  styleUrls: ['./dl-single-select-drivers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DlSingleSelectDriversComponent implements OnChanges {

  // selectedGroups: Array<ISingleSelectVehicleRow> = [];

  filter = '';
  dataSource: DriverDataSource;
  displayedColumns: string[] = ['first_name', 'id'];
  public defaultPageSize: number = 50;
  public pageDisplayOptions: Array<number> = [25, 50, 75, 100];

  @Input() driver: number = 0;
  @Input() refreshDriversList: boolean = false;
  @Input() selectedDriverName: string = '';
  @Input() labelText: string;
  @Output() outputSelectedDriver = new EventEmitter<number>();
  @Output() outputSelectedDriverName = new EventEmitter<string>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('singleSelectDriverSearch') tableSearchInput: ElementRef;

  constructor(private _driverService: DriverService) { }

  ngOnInit() {
    // Create new instance of datasource
    this.dataSource = new DriverDataSource(this._driverService);
    // Get first page of data
    this.loadInitialDrivers();
  }

  ngAfterViewInit() {
    // server-side search
    fromEvent(this.tableSearchInput.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap((event: Event) => {
          //const filterValue = (event.target as HTMLInputElement).value;
          //this.filter = filterValue.trim().toLowerCase();
          this.paginator.pageIndex = 0;
          this.loadDriverPage();
        })
      )
      .subscribe();

    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // on sort or paginate events, load a new page
    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
        tap(() => this.loadDriverPage())
    )
    .subscribe();
  }

  ngOnChanges() {
    console.log(this.refreshDriversList);
    if(this.refreshDriversList) {
        this.ngOnInit();
    }
  }

  public selectItem(item: IDriverForUserListRow) {
    this.refreshDriversList = false;
    this.driver = item.id;
    this.outputSelectedDriver.emit(item.id);
    this.selectedDriverName = this.getSelectedDriverName();
    this.outputSelectedDriverName.emit(this.selectedDriverName);
  }

  private clearTableSearch() {
    this.tableSearchInput.nativeElement.value = '';
    this.loadDriverPage();
  }

  private loadInitialDrivers() {
    const _params: PaginationParams = {
      pageSize: 50,
      page: 1,
      orderingDirection: '',
      ordering: 'first_name',
      search: ''
    };
    this.dataSource.loadDrivers(_params, true, this.driver);
  }

  public getSelectedDriverName() {
    console.log("hovering...");
    const driverObj = this.dataSource.findById(this.driver);
    console.log(driverObj);
    return driverObj ? driverObj.first_name + " " + driverObj.surname : "";
  }

  private loadDriverPage() {
    const _params: PaginationParams = {
      pageSize: this.paginator.pageSize,
      page: this.paginator.pageIndex + 1,
      orderingDirection: this.sort.direction,
      ordering:  this.sort.active,
      search: this.tableSearchInput.nativeElement.value
    };
    this.dataSource.loadDrivers(_params, true, this.driver);
  }
}


// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-single-select-drivers/dl-single-select-drivers.component.ts